import { ExpandableSection } from "../ExpandableSection";
import { Table } from "../Table";

const Section = ({ items, classes }) =>
  items?.length > 0 && (
    <ExpandableSection title="Outbound Clicks per URL" classes={classes}>
      <Table
        classes={classes}
        columns={outboundClicksTableColumns}
        items={items}
        keyField="url"
      />
    </ExpandableSection>
  );

const outboundClicksTableColumns = [
  { xs: 9, sm: 9, md: 9, label: "URL", field: "url" },
  { xs: 3, sm: 3, md: 3, label: "Clicks", field: "clickCount" },
];

export default Section;
